/* DVR - abre a pagina do produto na peca que a pessoa viu. (Claude, 27/09/2026)

   O ERRO QUE ISTO CORRIGE ERA MEU. Eu tinha construido a ponte escrevendo em
   dvr:vitrine, achando que era a chave que a pagina do produto le. Nao e: a
   pagina e movida pelo sistema vf, que nao guarda escolha nenhuma e abre
   sempre em Unissex, Frente, Branco. A chave chegava certa e ninguem lia.

   Como funciona agora. Nao existe chave para escrever, entao este arquivo faz
   o que a propria pessoa faria: clica nos botoes da pagina. Os botoes se
   identificam sozinhos, .vfm-mod[data-m], .vf-loc[data-k] e .vf-cor[data-k],
   e clicar neles dispara a logica da pagina inteira, sem eu precisar entender
   por dentro como ela monta a peca.

   E de uma vez so. A vitrine deixa um recado em dvr:abre, este arquivo cumpre
   e APAGA o recado. Sem isso, a pessoa que trocasse a cor na pagina e desse
   F5 veria a escolha dela ser desfeita por um recado antigo.

   Ordem importa: a modelagem primeiro, porque trocar de modelagem repinta a
   lista de locais e de cores. Por isso cada passo espera o anterior.

   01/10/2026, DUAS MUDANCAS.

   A primeira: o recado agora tambem pode vir pela URL, em ?mod=&cor=&loc=.
   Isso existe por causa dos anuncios. No carrossel do Meta cada cartao tem o
   seu proprio link, e o cartao mostra uma peca especifica (baby look rosa,
   ou a arte nas costas). Sem isso o anuncio promete uma peca e a pagina abre
   outra. Nao da para usar o ?variant= da Shopify para isso: modelagem NAO e
   variante, unissex e baby look sao a mesma variante e quem troca a peca e o
   seletor desta pagina. A URL ganha do localStorage quando as duas existem,
   porque o link clicado e a intencao mais recente.

   A segunda: a cor passou a casar pela PRIMEIRA PALAVRA SEM ACENTO. O rotulo
   da bolinha nem sempre e igual ao nome da cor: nas bolinhas que o motor
   acrescenta ela se chama "Cinza mescla", e a comparacao exata que estava
   aqui procurava "Cinza" e nao achava nada. Ou seja, a ponte vinda da barra
   da colecao ja falhava no cinza antes dos anuncios existirem.
*/
(function () {
'use strict';

var RECADO = 'dvr:abre';
var MOD = { uni: 'Unissex', bab: 'Baby look', ove: 'Oversized' };

function leRecado() {
  try {
    var r = JSON.parse(localStorage.getItem(RECADO) || 'null');
    if (!r || typeof r !== 'object') return null;
    return r;
  } catch (e) { return null; }
}
function apaga() { try { localStorage.removeItem(RECADO); } catch (e) {} }

/* o mesmo recado, vindo da URL do anuncio: ?mod=bab&cor=rosa&loc=costas.
   So os parametros que existirem sao usados, entao um link que so diz a cor
   deixa modelagem e local como a pagina abre. */
function daURL() {
  var q;
  try { q = new URLSearchParams(location.search); } catch (e) { return null; }
  var r = { mod: q.get('mod'), cor: q.get('cor'), loc: q.get('loc') };
  if (r.mod && !MOD[r.mod]) r.mod = null;
  if (!r.mod && !r.cor && !r.loc) return null;
  return r;
}

/* maiuscula na primeira letra: 'roxo' vira 'Roxo', que e como a pagina rotula */
function rotulo(s) {
  if (typeof s !== 'string' || !s) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
}

/* primeira palavra, sem acento, em minuscula. E com ela que os rotulos sao
   comparados, para "Cinza mescla" casar com "cinza". */
function chave(s) {
  return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().trim().split(/\s+/)[0];
}

/* o botao tem que estar visivel: a pagina desenha a barra duas vezes, uma para
   computador e outra para celular, e clicar na escondida nao produz efeito */
function visivel(e) {
  if (!e) return false;
  var r = e.getBoundingClientRect();
  return r.width > 0 && r.height > 0;
}
function acha(sel) {
  var todos = document.querySelectorAll(sel);
  for (var i = 0; i < todos.length; i++) if (visivel(todos[i])) return todos[i];
  return todos.length ? todos[0] : null;
}
/* procura pelo valor do atributo comparado por chave(), e nao por igualdade */
function achaPor(sel, attr, valor) {
  var todos = document.querySelectorAll(sel), a = chave(valor), reserva = null, i;
  for (i = 0; i < todos.length; i++) {
    if (chave(todos[i].getAttribute(attr)) !== a) continue;
    if (visivel(todos[i])) return todos[i];
    if (!reserva) reserva = todos[i];
  }
  return reserva;
}

/* ja esta escolhido? */
function escolhido(acharEl) {
  var b = acharEl();
  return !!(b && /\bon\b/.test(b.className || ''));
}
/* clica so se ainda nao estiver escolhido, para nao desfazer nada */
function marca(acharEl) {
  var b = acharEl();
  if (!b) return false;
  if (/\bon\b/.test(b.className || '')) return true;
  b.click();
  return true;
}

function cumpre(r, tentativa) {
  /* cada passo e uma funcao que PROCURA o botao na hora de usar, e nao um
     seletor guardado. Tem que ser assim: trocar de modelagem destroi e
     redesenha os botoes de local e de cor, entao um elemento guardado antes
     ja saiu de cena quando chega a vez dele. */
  var passos = [];
  if (r.mod && MOD[r.mod]) passos.push(function () {
    return achaPor('.vfm-mod[data-m]', 'data-m', MOD[r.mod]); });
  if (r.loc) passos.push(function () {
    return achaPor('.vf-loc[data-k]', 'data-k', rotulo(r.loc)); });
  if (r.cor) passos.push(function () {
    return achaPor('.vf-cor[data-k]', 'data-k', r.cor); });
  if (!passos.length) { apaga(); return; }

  /* se a barra ainda nao existe, espera: ela pode vir depois do HTML */
  if (!passos[0]()) {
    if (tentativa < 40) return setTimeout(function () { cumpre(r, tentativa + 1); }, 150);
    apaga();
    return;
  }

  /* Cada passo CONFERE se pegou, e repete se nao pegou.
     Tempo fixo nao serve: no primeiro teste o clique da modelagem saiu no
     DOMContentLoaded, antes de a pagina ligar o ouvinte daquele botao, e sumiu
     no vazio. Local e cor, que vinham 90 e 180 ms depois, pegaram. Conferir e
     repetir resolve sem eu precisar adivinhar quando cada parte fica pronta.
     Vinte e cinco tentativas de 120 ms dao tres segundos por passo: folga para
     celular lento, e se nunca pegar o arquivo desiste sem quebrar nada.

     28/09: eu tinha escrito acima que o clique sumia porque o ouvinte nao
     estava ligado. Fui ler os dois motores e nao e isso. O vf.js cria cada
     .vf-loc e cada .vf-cor JA com o onclick, e o vf-molde.js cria os dois
     .vfm-mod ja com o addEventListener. Nunca existe botao sem ouvinte: o que
     existe e o instante em que o botao ainda nao existe. Por isso a espera
     mudou de lugar (veja o fim do arquivo) em vez de crescer aqui. */
  var i = 0, vezes = 0;
  (function proximo() {
    if (i >= passos.length) { apaga(); return; }
    var p = passos[i];
    if (escolhido(p)) { i++; vezes = 0; return setTimeout(proximo, 60); }
    if (vezes++ >= 25) { i++; vezes = 0; return setTimeout(proximo, 60); }
    marca(p);
    /* trocar de modelagem redesenha os botoes de local e de cor, entao o
       proximo passo precisa acertar os novos, nao os que sairam de cena */
    setTimeout(proximo, 120);
  })();
}

function comeca() {
  /* a URL ganha: ela e o link que a pessoa acabou de clicar, o localStorage e
     uma escolha anterior. Quando vem pela URL o recado velho e jogado fora,
     senao ele voltaria a valer na proxima pagina. */
  var r = daURL();
  if (r) apaga();
  if (!r) r = leRecado();
  if (!r) return;
  /* 28/09: aqui tinha uma saida para as paginas de oversized, escrita quando
     eu achava que elas tinham motor proprio. Nao tem: elas sao movidas pelo
     mesmo sistema vf, com os mesmos botoes. A saida antiga fazia o recado ser
     jogado no lixo justamente na peca que mais precisava dele, entao quem
     escolhia verde nas costas e trocava para oversized abria em branco na
     frente. Saiu. */
  cumpre(r, 0);
}

/* QUANDO COMECAR. Antes era no load da pagina inteira, e isso custava caro:
   o load dessa pagina fica em torno de 2,8 s, e nesses 2,8 s a pessoa que
   escolheu baby look verde nas costas ficava olhando unissex branco na frente.
   Quem tem pressa clica em ADICIONAR nesse intervalo.

   Os dois motores montam os botoes no DOMContentLoaded, cada um com o ouvinte
   ja preso, entao esperar o load nao comprava nada. Comecamos no
   DOMContentLoaded e deixamos o load como segunda chance, para o caso de o
   bloco de modelagem nascer depois. A trava impede de cumprir duas vezes. */
var feito = false;
function abre() {
  if (feito) return;
  feito = true;
  comeca();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', abre);
else abre();
window.addEventListener('load', abre);
})();

/* ---- O NOME DA MODELAGEM NA TELA (Claude, 01/10/2026) ----
   Pedido dele: "so unissex fica meio amplo", e quem procura peca feminina nao
   reconhece "baby look" como resposta a busca dela. Ele cogitou criar uma
   categoria "Feminina" separada; nao criei de proposito, porque ela levaria ao
   MESMO lugar que a baby look (baby look ja e o corte feminino, nao e outro
   produto) e duas portas para a mesma sala confundem mais do que ajudam. As
   duas palavras foram para o mesmo rotulo.

   O CUIDADO QUE ESTE BLOCO TOMA: "Unissex", "Baby look" e "Oversized" nao sao
   so texto na tela. Sao o nome INTERNO que o vf-molde.js usa para montar a
   peca, que o data-m carrega, que o bloco de cima procura para cumprir o
   recado do anuncio, e que vai escrito na linha do pedido. Por isso aqui se
   troca SOMENTE o texto visivel, guardando o antigo em data-dvr-nome. Nenhum
   atributo e tocado, e apagar este bloco devolve tudo ao que era.

   DUAS LARGURAS, e isso veio do celular dele. Com os tres nomes longos a barra
   de modelagem passava da largura da tela e o terceiro botao sumia. Abaixo de
   680 px entra a versao curta. O menu lateral, que tem uma coluna inteira,
   fica sempre com o nome longo.

   O ESPACO DURO entre "baby" e "look": sem ele a quebra caia no meio do
   parenteses e saia "(baby" em cima com "look)" embaixo.

   A troca sai SEMPRE do nome original guardado, nunca do texto que esta na
   tela. E o que permite trocar de novo quando a pessoa gira o aparelho, sem o
   rotulo entrar em laco consigo mesmo.

   A medida em cm DENTRO do botao sai de cena (ver escondeMedida). Ela ja
   estava ali antes de eu mexer, vem do proprio tema, mas ele apontou que e
   repetida: a pessoa ve a medida de novo, e com mais detalhe, na hora de
   escolher o tamanho. O "em breve", que mora no MESMO elemento, continua,
   porque e o unico aviso de que aquela estampa ainda nao tem oversized.

   A mesma troca roda na pagina de colecao, mas la ela vive na secao "Ajustes
   da barra" do template, porque este arquivo nao e carregado la. */
(function () {
'use strict';

var CHAVE = { 'unissex': 'uni', 'baby look': 'bab', 'oversized': 'ove' };
var LONGO = { uni: 'Camiseta unissex', bab: 'Camiseta feminina (baby look)', ove: 'Camiseta oversized' };
var CURTO = { uni: 'Unissex', bab: 'Feminina (baby look)', ove: 'Oversized' };

function limpa(s) {
  return String(s || '').replace(/ /g, ' ').toLowerCase().replace(/\s+/g, ' ').trim();
}
function estreito() {
  try { return window.matchMedia('(max-width:680px)').matches; } catch (e) { return false; }
}

function aplica(el) {
  if (!el) return;
  var orig = el.getAttribute('data-dvr-nome');
  if (!orig) {
    orig = el.textContent || '';
    if (!CHAVE[limpa(orig)]) return;
    el.setAttribute('data-dvr-nome', orig.trim());
  }
  var k = CHAVE[limpa(orig)];
  if (!k) return;
  var novo = (estreito() ? CURTO : LONGO)[k];
  if (novo && el.textContent !== novo) el.textContent = novo;
}

/* a medida sai, o "em breve" fica. Os dois moram no mesmo <em>, entao a
   diferenca e feita pelo conteudo e nao por seletor. Mexo so no display, e o
   bloco das medidas da oversized so mexe no texto: um nao desfaz o outro. */
function escondeMedida() {
  var ems = document.querySelectorAll('.vfc-mod2 .vfm-mod > em');
  for (var i = 0; i < ems.length; i++) {
    var medida = /\d\s*(cm|×|x)\s*/i.test(ems[i].textContent || '');
    var querido = medida ? 'none' : '';
    if (ems[i].style.display !== querido) ems[i].style.display = querido;
  }
}

/* a linha "Escolha a modelagem : Unissex" repete a palavra que o botao aceso
   logo abaixo ja diz, e quem a repinta e o motor, a cada clique. Em vez de
   brigar com ele a cada repintura, a repeticao sai de cena por estilo. */
function estilo() {
  if (document.getElementById('dvr-rotulos-css')) return;
  var e = document.createElement('style');
  e.id = 'dvr-rotulos-css';
  e.textContent =
    '.vfc-mod2 .vf-ask .q{display:none !important}' +
    '.vfc-mod2 .vfm-mod > b{white-space:normal;line-height:1.2;text-wrap:balance}' +
    /* no celular o rotulo vira duas linhas em vez de encolher. Ideia dele:
       "ja que o resto esta em duas linhas", e assim ele devolve largura para
       os tres botoes, que e o que fazia o oversized sumir. */
    '@media (max-width:680px){' +
      '.vfc-mod2 .vf-ask{max-width:6.2em !important;white-space:normal !important;' +
        'line-height:1.15 !important;font-size:11px !important;letter-spacing:.03em !important;opacity:.78}' +
      '.vfc-mod2 .vfm-mod{padding-inline:8px !important}' +
      '.vfc-mod2 .vfm-mod > b{font-size:11.5px !important}' +
    '}';
  (document.head || document.documentElement).appendChild(e);
}

function roda() {
  /* o seletor visivel da pagina do produto: o nome ja mora num <b> proprio,
     separado do data-m, entao trocar o texto nao afeta nada por baixo */
  var bs = document.querySelectorAll('.vfc-mod2 .vfm-mod > b');
  for (var i = 0; i < bs.length; i++) aplica(bs[i]);
  escondeMedida();
  /* os tres itens do menu lateral sao os unicos links com mod= no endereco.
     La o nome longo cabe sempre, entao eles ficam de fora da versao curta. */
  var as = document.querySelectorAll('a[href*="mod=uni"], a[href*="mod=bab"], a[href*="mod=ove"]');
  for (var j = 0; j < as.length; j++) {
    var alvo = as[j].querySelector('span, b') || as[j];
    var orig = alvo.getAttribute('data-dvr-nome');
    if (!orig) {
      orig = alvo.textContent || '';
      if (!CHAVE[limpa(orig)]) continue;
      alvo.setAttribute('data-dvr-nome', orig.trim());
    }
    var k = CHAVE[limpa(orig)];
    if (k && alvo.textContent !== LONGO[k]) alvo.textContent = LONGO[k];
  }
}

try { estilo(); } catch (e) {}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', roda);
else roda();
window.addEventListener('load', roda);
window.addEventListener('resize', function () {
  clearTimeout(window.__dvrRot); window.__dvrRot = setTimeout(roda, 150);
});

/* a gaveta do menu nasce quando a pessoa abre, e o motor repinta o seletor ao
   trocar de modelagem. Trocar texto nao dispara childList em elemento novo, e
   a troca sai do original guardado: nao existe laco. */
if (window.MutationObserver) {
  var t = null;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(roda, 80); })
    .observe(document.documentElement, { subtree: true, childList: true });
}
})();

/* ---- A ARTE CLARA NA LUPA (Claude, 29/09/2026) ----
   O "ver a arte" mostra o arquivo da estampa sobre um fundo creme fixo, que
   esta no vf.css como .vf-lb img.art{background:#efe6d8}. Funciona para arte
   de traco escuro, que e a maioria. Nao funciona para arte de traco BRANCO,
   que e justamente a que o tema escurece sozinho quando ela cai sobre peca
   clara: na lupa ela aparece do jeito que o arquivo e, branco sobre creme, e
   nao da para ver nada. Aconteceu com a Coracao Micelial e com a Cogumelos
   da Lua, as duas que o Fredy redesenhou em traco.

   O conserto mede a propria arte quando a lupa abre: soma a luminosidade dos
   pixels que tem tinta e, se a media passar de 155, aquela imagem ganha fundo
   escuro. Arte escura continua no creme. Nenhum motor e tocado: e uma classe
   a mais na imagem e uma regra de estilo injetada aqui, entao apagar este
   bloco devolve tudo ao que era. */
(function () {
'use strict';
var cache = {};

function estilo() {
  if (document.getElementById('dvr-arte-clara')) return;
  var e = document.createElement('style');
  e.id = 'dvr-arte-clara';
  e.textContent = '.vf-lb img.art.dvr-escura{background:#12170e !important;' +
                  'border-color:rgba(212,179,106,.35) !important}';
  (document.head || document.documentElement).appendChild(e);
}

/* media de luminosidade so dos pixels com tinta. 320 px chega: a conta e de
   tom, nao de desenho, e num canvas menor ela sai na hora. */
function mede(src, cb) {
  if (cache[src] !== undefined) { cb(cache[src]); return; }
  var im = new Image();
  im.crossOrigin = 'anonymous';
  im.onload = function () {
    var N = 320, c = document.createElement('canvas'), d;
    c.width = N; c.height = N;
    try {
      var x = c.getContext('2d', { willReadFrequently: true });
      x.drawImage(im, 0, 0, N, N);
      d = x.getImageData(0, 0, N, N).data;
    } catch (e) { cache[src] = false; cb(false); return; }
    var L = 0, n = 0;
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] > 30) { L += 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2]; n++; }
    }
    var clara = n > 50 && (L / n) > 155;
    cache[src] = clara;
    cb(clara);
  };
  im.onerror = function () { cache[src] = false; cb(false); };
  im.src = src;
}

function olha() {
  var im = document.querySelector('.vf-lb img.art');
  if (!im) return;
  var s = im.currentSrc || im.getAttribute('src') || '';
  if (!s) { im.classList.remove('dvr-escura'); return; }
  /* ja medida: nao repete. a seta de proxima troca o src e cai aqui de novo. */
  if (im.getAttribute('data-dvr-src') === s) return;
  im.setAttribute('data-dvr-src', s);
  mede(s, function (clara) {
    var agora = im.currentSrc || im.getAttribute('src') || '';
    if (agora !== s) return;
    im.classList.toggle('dvr-escura', clara);
  });
}

try { estilo(); } catch (e) {}

/* a lupa e montada e trocada por JavaScript, entao o gatilho e o proprio DOM.
   trocar a classe da imagem cai aqui de volta, mas o data-dvr-src ja esta
   igual e a funcao sai na primeira linha: nao existe laco. */
if (window.MutationObserver) {
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(olha, 60);
  }).observe(document.documentElement, {
    subtree: true, childList: true, attributes: true, attributeFilter: ['src', 'class']
  });
}
document.addEventListener('click', function () {
  setTimeout(olha, 120); setTimeout(olha, 500);
}, true);
})();

/* ---- COR SEM VARIANTE NAO APARECE (Claude, 29/09/2026) ----
   O motor desenha as nove cores da linha em qualquer peca, mesmo quando o
   produto so tem duas. Depois que a oversized passou a existir so em preto e
   no off white (bege), as outras sete continuavam clicaveis e levavam a uma
   variante que nao existe mais. Aqui cada bolinha e conferida contra as
   variantes que a propria pagina publica no .vf-cfg, e a que nao tem variante
   some. A comparacao e pela primeira palavra sem acento, porque a bolinha as
   vezes tem nome mais longo que a variante ("Cinza mescla" contra "Cinza").
   Sem .vf-cfg, que e o caso da pagina de colecao, nada acontece. */
(function () {
'use strict';

function chave(s) {
  return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '')
    .toLowerCase().trim().split(/\s+/)[0];
}

function coresDoProduto() {
  var el = document.querySelector('.vf-cfg');
  if (!el) return null;
  var d;
  try { d = JSON.parse(el.textContent); } catch (e) { return null; }
  var vs = (d && d.variants) || [];
  if (!vs.length) return null;
  var m = {};
  for (var i = 0; i < vs.length; i++) m[chave(vs[i].option1)] = 1;
  return m;
}

function limpaCores() {
  var m = coresDoProduto();
  if (!m) return;
  var bs = document.querySelectorAll('.vf-cor');
  if (!bs.length) return;
  for (var i = 0; i < bs.length; i++) {
    var mostra = !!m[chave(bs[i].getAttribute('data-k'))];
    bs[i].style.display = mostra ? '' : 'none';
    if (!mostra) bs[i].setAttribute('data-dvr-fora', '1');
  }
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', limpaCores);
else limpaCores();
window.addEventListener('load', limpaCores);

/* o motor repinta a fila ao trocar de modelagem, entao a limpeza roda de novo.
   so observo nascimento de elemento: mexer no style nao cai aqui, nao ha laco. */
if (window.MutationObserver) {
  var t = null;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(limpaCores, 80);
  }).observe(document.documentElement, { subtree: true, childList: true });
}
})();